import React, { useState } from 'react';
import ActionMenu from '@lsq/nextgen/v2/action-menu';

/**
 * Wrapper around @lsq/nextgen/v2/action-menu ActionMenu.
 * Swap this file to change the underlying menu library project-wide.
 *
 * Props:
 *   actions   — array of { label: string, value: string, disabled?: bool }
 *   onSelect  — (item) => void   called with the selected action item
 *   children  — trigger element (e.g. the ⋮ icon)
 */
export default function LsqActionMenu({ actions = [], onSelect = () => {}, children, ...props }) {
  const [open, setOpen] = useState(false);

  const handleSelect = (item) => {
    setOpen(false);
    onSelect(item);
  };

  return (
    // <div onClick={(e) => e.stopPropagation()} style={{"cursor":"pointer"}}>
    <ActionMenu
      actions={actions}
      onSelection={handleSelect}
      open={open}
      onOpenChange={setOpen}
      trigger="click"
      {...props}>
      {children}
    </ActionMenu>
  );
}
